/* eslint-disable @typescript-eslint/no-explicit-any */

const STORAGE_PREFIX = 'eim_sort_';
const VALID_DIRECTIONS = ['asc', 'desc'] as const;

export type SortDirection = typeof VALID_DIRECTIONS[number];

export interface StoredSort {
  sortColumn: string;
  sortDirection: SortDirection;
}

export function writeSortToStorage(
  listKey: string,
  sortColumn: string,
  sortDirection: string
): void {
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${listKey}`,
      JSON.stringify({ sortColumn, sortDirection })
    );
  } catch {
    // Unavailable in some private-browsing environments.
  }
}

export function clearSortFromStorage(listKey: string): void {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${listKey}`);
  } catch {
    // Unavailable in some private-browsing environments.
  }
}

/**
 * Reads and validates the persisted sort for one list view.
 * Returns null if the value is absent, malformed, contains an unrecognised
 * column name, or contains an unrecognised direction — preventing untrusted
 * strings from reaching API query parameters.
 */
export function readSortFromStorage(
  listKey: string,
  validColumns: readonly string[]
): StoredSort | null {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${listKey}`);
    if (!raw) return null;
    const parsed: any = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed.sortColumn === 'string' &&
      validColumns.includes(parsed.sortColumn) &&
      (VALID_DIRECTIONS as readonly string[]).includes(parsed.sortDirection)
    ) {
      return {
        sortColumn: parsed.sortColumn,
        sortDirection: parsed.sortDirection as SortDirection,
      };
    }
    return null;
  } catch {
    return null;
  }
}
